import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, FunctionComponent } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { User } from '../../../classes/entities/User/userTypes';
import { UserListItem } from '../UserListItem/UserListItem';

export type UserListProps = Omit<ComponentProps<'div'>, 'children'> & {
  users: Array<User>;
  children?: Array<never> | never;
};

export const UserList: FunctionComponent<UserListProps> = React.memo(
  (props) => {
    const { users, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });

    return (
      <div {...remainingProps}>
        {users.map((user) => {
          return (
            <UserListItem
              user={user}
              key={EntityUtils.getTrackingKey(user)}
              data-testid="UserList.UserListItem"
            ></UserListItem>
          );
        })}
      </div>
    );
  }
);
